import { useQuery } from '@tanstack/react-query';
import { enterpriseApiClient } from '../../client';
import { WorkOrdersApi } from '../../openapi';
import type { WorkOrderChargeViewModel } from '../../openapi';
import { workOrderKeys } from '../constants';
import { CACHE_TIMINGS } from '@api/constants';

export const useWorkOrderCharges = (jobNumber: string, enabled = true) => {
  const workOrdersApi = new WorkOrdersApi(
    undefined,
    undefined,
    enterpriseApiClient
  );

  return useQuery<WorkOrderChargeViewModel[], Error>({
    queryKey: workOrderKeys.charges(jobNumber),
    queryFn: async () => {
      const response = await workOrdersApi.apiWorkOrdersJobNumberChargesGet({
        jobNumber
      });
      return response.data;
    },
    enabled: enabled && !!jobNumber,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    ...CACHE_TIMINGS.WORK_ORDER
  });
};
